<template>
    <div class="tab-pane active p-20">
        <h4 class="header-title m-0 text-dark"><i class="fa-fw fa ti-briefcase m-r-10"></i>{{ $t('company_info') }}</h4>
        <hr>
        <form class="form-horizontal" @submit.prevent="update()">
            <div class="row">
                <div class="col-sm-6 m-b-15" :class="{'has-error': errors['name']}">
                    <label>{{ $t('name') }}</label>
                    <input type="text" v-model="record.name" class="form-control">
                    <span class="error" v-if="errors['name']">{{ errors['name'][0] }}</span>
                </div>
                <div class="col-sm-6 m-b-15" :class="{'has-error': errors['fancy_name']}">
                    <label>{{ $t('fancy_name') }}</label>
                    <input type="text" v-model="record.fancy_name" class="form-control">
                    <span class="error" v-if="errors['fancy_name']">{{ errors['fancy_name'][0] }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 m-b-15" :class="{'has-error': errors['document']}">
                    <label>{{ $t('document') }}</label>
                    <input type="text" v-model="record.document" class="form-control">
                    <span class="error" v-if="errors['document']">{{ errors['document'][0] }}</span>
                </div>
                <div class="col-sm-6 m-b-15" :class="{'has-error': errors['email']}">
                    <label>{{ $t('email') }}</label>
                    <input type="text" v-model="record.email" class="form-control">
                    <span class="error" v-if="errors['email']">{{ errors['email'][0] }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 m-b-15" :class="{'has-error': errors['phone']}">
                    <label>{{ $t('phone') }}</label>
                    <input type="text" v-model="record.phone" class="form-control">
                    <span class="error" v-if="errors['phone']">{{ errors['phone'][0] }}</span>
                </div>
                <div class="col-sm-6 m-b-15" :class="{'has-error': errors['address']}">
                    <label>{{ $t('address') }}</label>
                    <input type="text" v-model="record.address" class="form-control">
                    <span class="error" v-if="errors['address']">{{ errors['address'][0] }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 m-b-15" :class="{'has-error': errors['complement']}">
                    <label>{{ $t('complement') }}</label>
                    <input type="text" v-model="record.complement" class="form-control">
                    <span class="error" v-if="errors['complement']">{{ errors['complement'][0] }}</span>
                </div>
                <div class="col-sm-6 m-b-15" :class="{'has-error': errors['district']}">
                    <label>{{ $t('district') }}</label>
                    <input type="text" v-model="record.district" class="form-control">
                    <span class="error" v-if="errors['district']">{{ errors['district'][0] }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 m-b-15" :class="{'has-error': errors['zip_code']}">
                    <label>{{ $t('zip_code') }}</label>
                    <input type="text" v-model="record.zip_code" class="form-control">
                    <span class="error" v-if="errors['zip_code']">{{ errors['zip_code'][0] }}</span>
                </div>
                <div class="col-sm-6 m-b-15" :class="{'has-error': errors['city']}">
                    <label>{{ $t('city') }}</label>
                    <input type="text" v-model="record.city" class="form-control">
                    <span class="error" v-if="errors['city']">{{ errors['city'][0] }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 m-b-15" :class="{'has-error': errors['state']}">
                    <label>{{ $t('state') }}</label>
                    <input type="text" v-model="record.state" class="form-control">
                    <span class="error" v-if="errors['state']">{{ errors['state'][0] }}</span>
                </div>
                <div class="col-sm-6 m-b-15" :class="{'has-error': errors['country_id']}">
                    <label>{{ $t('country') }}</label>
                    <pml-select-countries v-model="record.country_id"></pml-select-countries>
                    <span class="error" v-if="errors['country_id']">{{ errors['country_id'][0] }}</span>
                </div>
            </div>
            <hr class="m-t-5">
            <div class="clearfix">
                <span class="btn btn-white" @click.prevent="cancel()">{{ $t('cancel') }}</span>
                <button class="btn btn-default pull-right" type="submit" v-pml-block="isSaving">{{ $t('update') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { update } from 'services/company'
    import { mapGetters } from 'vuex'
    import { cloneDeep } from 'lodash'

    export default {
        name: 'Info',
        data () {
            return {
                record: {},
                errors: [],
                isSaving: false
            }
        },
        computed: {
            ...mapGetters({
                company: 'getCompany'
            })
        },
        mounted () {
            this.record = cloneDeep(this.company)
        },
        methods: {
            update () {
                this.isSaving = true
                delete this.record['logo']
                delete this.record['logo_url']
                update(this.record)
                    .then(() => {
                        Notify.success(trans('_notifications.success'))
                        this.errors = []
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            },
            cancel () {
                this.record = cloneDeep(this.company)
                this.errors = []
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/company/components/Info.vue